import { Injectable } from '@angular/core';
import { Inscrit } from '../model/model.inscrit';
import {Famille} from "../model/model.famille";
import { HttpClient,HttpHeaders,HttpErrorResponse,HttpParams} from '@angular/common/http';
import { map ,catchError, switchMap} from 'rxjs/operators';
import {Observable, throwError,of} from 'rxjs';
import { Personnel } from '../model/model.personnel';
import { environment } from 'src/environments/environment';
import { PersonnelService } from './personnel.service';
import { Sort } from '@angular/material/sort';
@Injectable()
export class InscritService {

  basePath = environment.BasePath+"/survey";

  constructor( private httpClient:HttpClient,
    private personnelService: PersonnelService // Injecter PersonnelService
   ) {
  }

  getInscrits(motCle: string): Observable<any> {

    return this.httpClient.get(this.basePath + "/chercheInscrit?nom="+motCle)
  }

  addNewPayementRef(newRefToSave: any) : Observable<any>{
    return  this.httpClient.post(this.basePath + "/ref/save", newRefToSave )
  }

  checkPaymentInscrits(month: string, year: string, type: string) {
    return this.httpClient.get(this.basePath + "/check/payment/"+month+"/"+year+"/"+type)
  }


  getInscritsAmountPayed(id: any, ref: string, type:string): Observable<any> {
    return this.httpClient.get(this.basePath + "/amount/payed/"+id+"/"+ref+"/"+type)
  }

  getDesactiveInscrits(motCle: string): Observable<any> {

    return this.httpClient.get(this.basePath + "/chercheDesactiveInscrit?nom="+motCle)
  }

getAllInscrits(params: any): Observable<any> {
  let httpParams = new HttpParams()
    .set('page', params.page.toString())
    .set('size', params.size.toString())
    .set('archived', params.archived.toString());

  if (params.nom) httpParams = httpParams.set('nom', params.nom);
  if (params.prenom) httpParams = httpParams.set('prenom', params.prenom);
  if (params.gender) httpParams = httpParams.set('gender', params.gender);
  if (params.niveauScolaire && params.niveauScolaire.length > 0) {
    (Array.isArray(params.niveauScolaire) ? params.niveauScolaire : [params.niveauScolaire])
      .forEach((val: string) => { httpParams = httpParams.append('niveauScolaire', val); });
  }
  if (params.ageMin) httpParams = httpParams.set('ageMin', params.ageMin);
  if (params.ageMax) httpParams = httpParams.set('ageMax', params.ageMax);
  if (params.telephone) httpParams = httpParams.set('telephone', params.telephone);
  if (params.type) httpParams = httpParams.set('type', params.type);
  if (params.chefFamille) httpParams = httpParams.set('chefFamille', params.chefFamille);
  if (params.kafalaType) httpParams = httpParams.set('kafalaType', params.kafalaType);
  if (params.prenomF) httpParams = httpParams.set('prenomF', params.prenomF);
  if (params.typeEtablissement) httpParams = httpParams.set('typeEtablissement', params.typeEtablissement); // Ajouter le filtre
  if (params.anneeScolaireFrom) httpParams = httpParams.set('anneeScolaireFrom', params.anneeScolaireFrom);
  if (params.anneeScolaireTo) httpParams = httpParams.set('anneeScolaireTo', params.anneeScolaireTo);
  if (params.moyenne) httpParams = httpParams.set('moyenne', params.moyenne); // Nouveau filtre pour la moyenne
  if (params.statut) httpParams = httpParams.set('statut', params.statut); // Nouveau filtre pour le statut (admis/non admis)
  if (params.bulletinTrimestre) httpParams = httpParams.set('bulletinTrimestre', params.bulletinTrimestre);
  if (params.bulletinRendu) httpParams = httpParams.set('bulletinRendu', params.bulletinRendu);
  const headers = { 'idEtab': sessionStorage.getItem('idEtab') || '' };

  return this.httpClient.get<any>(`${this.basePath}/inscrit`, { params: httpParams, headers }).pipe(
    switchMap(response => {
      const inscrits = response.content as Inscrit[];
      const idEtab = sessionStorage.getItem('idEtab') || '1';
      return this.personnelService.getKafelPersonnel(+idEtab).pipe(
        map((kafils: any[]) => {
          const updatedInscrits = inscrits.map(inscrit => {
            const kafil = kafils.find(k => k.id === inscrit.personnelId);
            return {
              ...inscrit,
              nomKafil: kafil ? `${kafil.prenom} ${kafil.nom}` : 'غير محدد'
            };
          });
          return {
            ...response,
            content: updatedInscrits
          };
        })
      );
    }),
    catchError((error) => {
      console.error('Error fetching inscrits:', error);
      return of({ content: [], totalElements: 0 });
    })
  );
}
  getInscritsById(id: number): Observable<any>{
    return this.httpClient.get(this.basePath + "/inscrit/"+id)
  }


  saveInscrit(inscrit: Inscrit): Observable<any> {

    return this.httpClient.post(this.basePath + "/inscrit",inscrit)
  }
 

  editInscrit(inscrit: Inscrit): Observable<any> {
    const headers = { 'idEtab': sessionStorage.getItem('idEtab') || '' };
    console.log('Envoi de la requête PUT avec:', inscrit); // Journaliser les données envoyées
    return this.httpClient.put(this.basePath + "/inscrit/" + inscrit.id, inscrit, { headers }).pipe(
        map(response => {
            console.log('Réponse du backend:', response); // Journaliser la réponse
            return response;
        }),
        catchError((error: HttpErrorResponse) => {
            console.error('Erreur lors de la mise à jour de l\'inscrit:', error);
            return throwError(() => new Error(`Erreur lors de la mise à jour: ${error.status} - ${error.error?.message || error.message || 'Erreur inconnue'}`));
        })
    );
}

  getInscritsByFamilyId(familyID: number): Observable<any> {
    return this.httpClient.get<any>(this.basePath + "/inscrit/family/" + familyID);
  }

  deleteInscrit(id:number): Observable<any>{

    return this.httpClient.delete(this.basePath + "/inscrit/"+id)
  }

  uploadImage(file:FormData): Observable<any>{

    return this.httpClient.post(this.basePath + "/img",file)
  }

  getPdf(): Observable<any> {

    return this.httpClient.get(this.basePath + "//Exportpdf");
  }

  // Nouvelles méthodes pour archiver, désarchiver et récupérer les inscrits archivés
  archiveInscrit(id: number): Observable<any> {
    return this.httpClient.put(`${this.basePath}/inscrit/${id}/archive`, {});
  }

  unarchiveInscrit(id: number): Observable<any> {
    return this.httpClient.put(`${this.basePath}/inscrit/${id}/unarchive`, {});
  }
  



getInscritsWithExpiringAndExpiredKafala(idEtab: number, page: number = 0, size: number = 10, sort?: Sort, status?: string): Observable<any> {
  let httpParams = new HttpParams()
    .set('page', page.toString())
    .set('size', size.toString());

  if (sort && sort.active && sort.direction) {
    httpParams = httpParams.set('sort', `${sort.active},${sort.direction}`);
  }

  if (status && status !== 'ALL') {
    httpParams = httpParams.set('status', status);
  }

  const headers = new HttpHeaders({ idEtab: idEtab.toString() });
  return this.httpClient.get<any>(`${this.basePath}/inscrit/expiring-kafalas`, { params: httpParams, headers });
}




  getExpiringAndExpiredKafalaCount(idEtab: number): Observable<number> {
    const headers = new HttpHeaders({ idEtab: idEtab.toString() });
    return this.httpClient.get<number>(`${this.basePath}/inscrit/expiring-kafalas/count`, { headers });
  }
  updateAcademicData(inscritId: number, academicData: any[]): Observable<any> {
    const headers = { 'idEtab': sessionStorage.getItem('idEtab') || '' };
    const payload = { academicData: JSON.stringify(academicData) };
    return this.httpClient.put(`${this.basePath}/inscrit/${inscritId}/academic-data`, payload, { headers }).pipe(
        catchError((error: HttpErrorResponse) => {
            console.error('Erreur lors de la mise à jour des données académiques:', error);
            return throwError(() => new Error(`Erreur lors de la mise à jour: ${error.status} - ${error.error?.message || error.message || 'Erreur inconnue'}`));
        })
    );
  }

  // Nouvelle méthode pour récupérer toutes les années scolaires distinctes
  getDistinctAcademicYears(): Observable<string[]> {
    const headers = { 'idEtab': sessionStorage.getItem('idEtab') || '' };
    return this.httpClient.get<string[]>(`${this.basePath}/inscrit/academic-years`, { headers }).pipe(
      catchError((error) => {
        console.error('Error fetching academic years:', error);
        return of([]);
      })
    );
  }
}